import { setCookie, destroyCookie } from 'nookies';

import ServiceConfigs from 'service/config';
import { getFullDomain } from 'common/utils';
import { USER_PHONE_NUMBER, USER_SUBDOMAIN } from '../../../common/constants';

export const setUserInfoCookies = (phoneNumber: string): void => {
  const subdomain = ServiceConfigs.getSubDomain();
  destroyCookie(null, USER_PHONE_NUMBER, {
    path: '/',
  });
  destroyCookie(null, USER_SUBDOMAIN, {
    path: '/',
  });
  setCookie(null, USER_PHONE_NUMBER, phoneNumber.slice(1), {
    path: '/',
    maxAge: 4 * 7 * 24 * 60 * 60, // save for 1 week
    domain: getFullDomain(),
  });
  setCookie(null, USER_SUBDOMAIN, subdomain, {
    path: '/',
    maxAge: 4 * 7 * 24 * 60 * 60, // save for 1 week
    domain: getFullDomain(),
  });
};
